// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2557a","col":"styles_col__3-L6N","actions":"styles_actions__z1Dj7","conflict":"styles_conflict__1rsRm"};